require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./yamhill-street-vacant-property.json") })
        }
      }, "path---yamhill-street-vacant-property");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---yamhill-street-vacant-property!./.cache/json/yamhill-street-vacant-property.json
// module id = 1070
// module chunks = 231608221292675